module.exports = __webpack_public_path__ + "img/banner-1-m.485ca31f.jpg";